// import Upload from '@/components/Upload';
import { Button, Col, Form, Input, Modal, Row, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import { useMap } from '@/hooks/useMap';

const MapContainer = ({
  onCancel,
  onConfirm,
  baseData,
  mapKey,
}: {
  onCancel: () => void;
  baseData: { lat?: number; lon?: number; location?: string };
  onConfirm: (info: { lng?: number; lat?: number; detail?: string; lon?: number }) => void;
  mapKey: string;
}) => {
  const mapRef = useRef(null);
  const placeSearchRef = useRef(null);
  const markerRef = useRef(null);
  const autoRef = useRef(null);
  const geocoderRef = useRef(null);
  const AMapRef = useRef(null);

  const [addressInfo, setAddressInfo] = useState<{ lng?: number; lat?: number; detail?: string }>({ lat: baseData.lat, lng: baseData.lon });

  const getAddressInfo = (location: { lng: number; lat: number }, isInitial?: boolean) => {
    const { lng, lat } = location;
    // console.log(lng, lat);
    // @ts-ignore
    if (!isInitial) markerRef.current?.setPosition([lng, lat]);
    // @ts-ignore
    mapRef.current?.setCenter(location);
    // @ts-ignore
    geocoderRef.current?.getAddress(location, (...args) => {
      // console.log({ args }, args[1].regeocode.formattedAddress);
      try {
        setAddressInfo({ lng, lat, detail: args[1].regeocode.formattedAddress });
      } catch {
        // @ts-ignore
        // mapRef.current?.setCenter([116.406315, 39.908775]);
      }
    });
  };

  const getInitialAddress = () => {
    if (baseData.lat && baseData.lon) {
      return [Number(baseData.lon), Number(baseData.lat)];
    }
    return [116.406315, 39.908775];
  };
  const initialMap = async () => {
    // console.log(baseData);
    try {
      const AMap = await AMapLoader.load({
        key: mapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      });
      AMapRef.current = AMap;
      mapRef.current = new AMap.Map('map-container', {
        viewMode: '2D', // 是否为3D地图模式
        zoom: 13, // 初始化地图级别
        center: getInitialAddress(),
        resizeEnable: true,
      });
      // geocoderRef.current = new AMap.Geocoder({});
      AMap.plugin(['AMap.AutoComplete', 'AMap.PlaceSearch', 'AMap.Geocoder'], function () {
        geocoderRef.current = new AMap.Geocoder({});
        autoRef.current = new AMap.AutoComplete({ input: 'map-search' });
        // console.log(autoRef.current);
        placeSearchRef.current = new AMap.PlaceSearch({
          pageSize: 1, // 单页显示结果条数
          pageIndex: 1, // 页码
          // citylimit: true, // 是否强制限制在设置的城市内搜索
          panel: false,
          map: mapRef.current, // 展现结果的地图实例
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker 点都处于视口的可见范围
        });
        // @ts-ignore
        placeSearchRef.current.on('markerClick', ({ data }) => {
          // console.log({ args });
          getAddressInfo(data.location);
        });

        // @ts-ignore
        autoRef.current.on('select', function (e) {
          // console.log({ e });
          // 针对选中的poi实现自己的功能
          setSearchValue(e.poi.name);
          // @ts-ignore
          placeSearchRef.current.search(e.poi.name, (status, { poiList: { pois } }) => {
            // console.log(pois);
            try {
              const { location } = pois[0];
              // const { lat, lng } = location;
              getAddressInfo(location);
            } catch {}
          });
        });
        if (baseData.lat && baseData.lon) {
          getAddressInfo(new AMap.LngLat(baseData.lon, baseData.lat), true);
        }
      });
      markerRef.current = new AMap.Marker({
        position: getInitialAddress(),
        offset: new AMap.Pixel(1, 1),
        zIndex: 300,
      });
      // @ts-ignore
      markerRef.current?.setMap?.(mapRef.current);
      // @ts-ignore
      mapRef.current?.on('click', (e) => {
        // console.log({ e });
        const { lnglat } = e;
        // const { lat, lng } = lnglat;
        getAddressInfo(lnglat);
      });
      // @ts-ignore
    } catch {}
  };

  useEffect(() => {
    initialMap();
    // console.log({ baseData });
    return () => {
      // @ts-ignore
      mapRef.current?.destroy?.();
    };
  }, []);

  const [searchValue, setSearchValue] = useState<string>('');

  const [searchData, setSearchData] = useState<{ lat?: string; lng?: string }>({});

  return (
    <div>
      <Row gutter={[10, 10]}>
        <Col span={12}>
          <Input
            placeholder="请输入地点搜索"
            id="map-search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
          ></Input>
        </Col>
      </Row>
      <Row gutter={[10, 10]} style={{ marginTop: '10px' }}>
        <Col span={10}>
          <Input
            addonBefore="经度"
            value={searchData.lng}
            onChange={(e) => {
              setSearchData((pre) => ({ ...pre, lng: e.target.value }));
            }}
          ></Input>
        </Col>
        <Col span={10}>
          <Input
            addonBefore="纬度"
            value={searchData.lat}
            onChange={(e) => {
              setSearchData((pre) => ({ ...pre, lat: e.target.value }));
            }}
          ></Input>
        </Col>
        <Col span={4}>
          <Button
            type="primary"
            onClick={() => {
              // @ts-ignore
              getAddressInfo(new AMapRef.current.LngLat(searchData.lng, searchData.lat));
              // console.log();
            }}
            disabled={!searchData.lat || !searchData.lng}
          >
            查询
          </Button>
        </Col>
      </Row>
      <div style={{ height: 'calc(80vh - 160px)', margin: '10px auto', maxHeight: '600px', minHeight: '200px' }}>
        <div id="map-container" style={{ height: '100%' }}></div>
      </div>
      <Row gutter={[10, 10]}>
        <Col span={12}>
          <Input addonBefore="经度" readOnly value={addressInfo.lng}></Input>
        </Col>
        <Col span={12}>
          <Input addonBefore="纬度" readOnly value={addressInfo.lat}></Input>
        </Col>
        <Col span={24}>
          <Input addonBefore="详细地址" readOnly value={addressInfo.detail}></Input>
        </Col>
      </Row>
      <div style={{ textAlign: 'right', marginTop: '10px' }}>
        <Space>
          <Button
            onClick={() => {
              onCancel?.();
            }}
          >
            取消
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onConfirm({ ...addressInfo, lon: addressInfo.lng });
              onCancel();
            }}
            disabled={!addressInfo.lat || !addressInfo.lng}
          >
            确定
          </Button>
        </Space>
      </div>
    </div>
  );
};

const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

interface MapFormItemsProps {
  isOnlyMap?: boolean;
  protocol?: string;
}

const MapFormItems = (props?: MapFormItemsProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const { mapKey, isInitialled } = useMap();

  console.log('props', props?.protocol);

  return (
    <>
      <Form.Item name="lat" noStyle>
        <div></div>
      </Form.Item>
      <Form.Item name="lon" noStyle>
        <div></div>
      </Form.Item>
      <Form.Item dependencies={['lat', 'lon']} noStyle>
        {({ getFieldValue, setFieldsValue }) => {
          const lat = getFieldValue('lat');
          const lon = getFieldValue('lon');
          return (
            <>
              <Modal
                title="地图选点"
                open={open}
                onCancel={() => {
                  setOpen(false);
                }}
                centered
                width={'80vw'}
                cancelText="取消"
                okText="确定"
                destroyOnClose
                footer={null}
              >
                {!isInitialled || !mapKey ? (
                  '地图配置出错，请重新配置再试'
                ) : (
                  <MapContainer
                    onCancel={() => {
                      setOpen(false);
                    }}
                    onConfirm={(info) => {
                      setFieldsValue({ ...info, location: info.detail });
                    }}
                    baseData={{ lat, lon }}
                    mapKey={mapKey}
                  ></MapContainer>
                )}
              </Modal>
              <Form.Item label="设备坐标">
                <Input
                  placeholder="请选择设备坐标"
                  value={lat && lon ? `${lat},${lon}` : ''}
                  onClick={() => {
                    setOpen(true);
                  }}
                  readOnly
                ></Input>
              </Form.Item>
              <Form.Item label="设备详细地址" name="location">
                <Input placeholder="请输入设备详细地址" readOnly></Input>
              </Form.Item>
              {!props?.isOnlyMap && (props?.protocol === 'ModbusRTU' || props?.protocol === 'ModbusTCP') && (
                <>
                  {props?.protocol !== 'ModbusRTU' && (
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label="设备IP地址"
                          name="ip"
                          rules={[
                            { required: true, message: '请输入设备IP地址' },
                            {
                              pattern: ipRegex,
                              message: '请输入有效的IPv4地址，例如 192.168.1.1',
                            },
                          ]}
                        >
                          <Input placeholder="请输入设备IP地址" allowClear />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="设备端口"
                          name="port"
                          rules={[
                            { required: true, message: '请输入设备端口' },

                            {
                              pattern: /^(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]?\d{1,4})$/,
                              message: '请输入有效端口号 (1-65535)',
                            },
                          ]}
                        >
                          <Input placeholder="请输入设备端口" allowClear />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item label="从设备ID" name="slaveId" rules={[{ required: true, message: '请输入从设备ID' }]}>
                        <Input placeholder="请输入从设备ID" style={{ width: '100%' }}></Input>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="采集时间" name="period" rules={[{ required: true, message: '请输入从设备采集时间' }]}>
                        <Input placeholder="请输入设备采集周期，单位秒" style={{ width: '100%' }}></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item label="设备工厂" name="manufacturer">
                    <Input placeholder="请输入设备工厂" allowClear></Input>
                  </Form.Item>
                  <Form.Item label="设备型号" name="model">
                    <Input placeholder="请输入设备型号" allowClear></Input>
                  </Form.Item>
                </>
              )}
            </>
          );
        }}
      </Form.Item>
    </>
  );
};
export default MapFormItems;
